/**
 * VC Back to Top Button
 * Floating action button for smooth scroll to top
 */

if (!customElements.get('vc-back-to-top')) {
  customElements.define(
    'vc-back-to-top',
    class VCBackToTop extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button');
        this.threshold = 500;
        this.ticking = false;
        this.scrollTarget = (this.dataset.scrollTarget || 'top').toLowerCase();
      }

      connectedCallback() {
        if (!this.button) return;

        // Bind scroll handler
        this.scrollHandler = this.handleScroll.bind(this);
        window.addEventListener('scroll', this.scrollHandler, { passive: true });

        // Bind click handler
        this.clickHandler = this.handleClick.bind(this);
        this.button.addEventListener('click', this.clickHandler);

        this.handleScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.scrollHandler);
        if (this.button) {
          this.button.removeEventListener('click', this.clickHandler);
        }
      }

      handleScroll() {
        if (this.ticking) return;

        this.ticking = true;
        requestAnimationFrame(() => {
          const currentScrollY = window.scrollY;
          const maxScroll = Math.max(
            document.documentElement.scrollHeight,
            document.body.scrollHeight
          ) - window.innerHeight;
          const distanceToBottom = Math.max(maxScroll - currentScrollY, 0);
          const shouldShow =
            this.scrollTarget === 'bottom'
              ? distanceToBottom > this.threshold
              : currentScrollY > this.threshold;

          if (shouldShow) {
            this.show();
          } else {
            this.hide();
          }

          this.ticking = false;
        });
      }

      handleClick() {
        // Trigger pulse animation
        this.button.classList.add('is-pulsing');
        setTimeout(() => {
          this.button.classList.remove('is-pulsing');
        }, 600);

        const targetPosition =
          this.scrollTarget === 'bottom'
            ? Math.max(
                document.documentElement.scrollHeight,
                document.body.scrollHeight
              ) - window.innerHeight
            : 0;

        window.setTimeout(() => {
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }, 140);
      }

      show() {
        this.hidden = false;
        this.classList.add('is-visible');
        this.button.classList.add('is-visible');
        this.button.removeAttribute('tabindex');
        this.button.removeAttribute('aria-hidden');
      }

      hide() {
        this.classList.remove('is-visible');
        this.button.classList.remove('is-visible');
        this.button.setAttribute('tabindex', '-1');
        this.button.setAttribute('aria-hidden', 'true');
        this.hidden = true;
      }
    }
  );
}
